import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconLayerGroup } from '@sorare/core/src/atoms/icons/system/iconLayerGroup.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { transferMarket } from '@sorare/core/src/lib/glossary';

const Root = styled(Horizontal).attrs({ gap: 0 })`
  height: 27px;
  color: var(--c-white);
`;
const Icon = styled(FontAwesomeIcon)`
  color: var(--c-onBase-success);
  margin-right: 5px;
`;

export const Bundle = () => {
  return (
    <Root>
      <Icon icon={iconLayerGroup} />
      <LabelS bold>
        <FormattedMessage {...transferMarket.bundle} />
      </LabelS>
    </Root>
  );
};
